import type { CreativeAd, TermRef } from '../types'

/**
 * The distinct dominant motivations across a set of creatives, most frequent
 * first (ties keep first-appearance order).
 */
export function dominantMotivationsOf(creatives: readonly CreativeAd[]): TermRef[] {
  const counts = new Map<string, { motivation: TermRef; count: number }>()
  for (const ad of creatives) {
    for (const motivation of ad.dominantMotivations) {
      const entry = counts.get(motivation.id)
      if (entry) entry.count += 1
      else counts.set(motivation.id, { motivation, count: 1 })
    }
  }
  return Array.from(counts.values())
    .sort((a, b) => b.count - a.count)
    .map((entry) => entry.motivation)
}
